import { render, staticRenderFns } from "./basicData.vue?vue&type=template&id=298bf646&scoped=true&"
import script from "./basicData.vue?vue&type=script&lang=js&"
export * from "./basicData.vue?vue&type=script&lang=js&"
import style0 from "./basicData.vue?vue&type=style&index=0&id=298bf646&scoped=true&lang=scss&"
import style1 from "./basicData.vue?vue&type=style&index=1&id=298bf646&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "298bf646",
  null
  
)

export default component.exports